module.exports = __webpack_public_path__ + "static/media/favicon.c43d1a8f.png";